var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SlideInModalPortal } from 'syf-component-library/ui/patterns/SlideInModalPortal';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { ErrorSource, QuestionnaireFlow } from '../../../redux/questionnaire/typings';
import { t } from '../../../strings/i18n/i18n';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import { ModalType } from '../../../redux/ui/typings';
import LaunchPointName from '../../../const/launchPointName';
import useDDPreventScroll from '../../../hooks/useDDPreventScrolling';
import { debounce } from 'lodash';
import DisputeModalHeader from '../../../ui/organisms/DisputeModalHeader';
import SLIDE_IN_MODAL_CONTAINER_ID from '../../../const/modalContainerIds';
import { determinePrimaryButtonTitleAndText, handlePrimaryButtonClick } from './helpers/primaryHandlers';
import { determineSecondaryButtonHandler, determineSecondaryButtonTitleAndText, determineSecondaryButtonType } from './helpers/secondaryHandlers';
import { CustomModalFooter } from './subcomponents';
import getHeaderAnalyticsTags from './helpers/getHeaderAnalyticsTags';
var isPrimaryButtonDisabled = function (step, isLoading, formError, additionalFieldFormError) {
    if (step === QuestionnaireFlow.CancelQuestionnaire) {
        return false;
    }
    if (formError || additionalFieldFormError) {
        return true;
    }
    return isLoading;
};
var isSecondaryButtonDisabled = function (step, isLoading) {
    return step === QuestionnaireFlow.CancelQuestionnaire ? false : isLoading;
};
var SlideInModal = function (_a) {
    var children = _a.children, id = _a.id, onCloseModal = _a.onCloseModal;
    var dispatch = useDispatch();
    var pointOfNeedChat = useIVASetChatStatus().pointOfNeedChat;
    var _b = useSelector(function (state) { return state; }, shallowEqual), _c = _b.caseDetails, postCasesCount = _c.postCasesCount, lowBalanceDisputeApplied = _c.lowBalanceDisputeApplied, _d = _b.ui, isLoading = _d.isLoading, modalType = _d.modalType, formError = _d.formError, additionalFieldFormError = _d.additionalFieldFormError, _e = _b.questionnaire, step = _e.step, source = _e.businessError.source, isRedispute = _e.isRedispute, currentQuestion = _e.currentQuestion, accountId = _b.appConfig.accountId;
    useDDPreventScroll();
    // @TODO need to consolidate creating this errorData / maybe create a helper to format this
    var errorData = {
        source: source,
        count: postCasesCount
    };
    var primaryButtonDisabled = isPrimaryButtonDisabled(step, isLoading, formError, additionalFieldFormError);
    var secondaryButtonDisabled = isSecondaryButtonDisabled(step, isLoading);
    var _f = determinePrimaryButtonTitleAndText(step, errorData, modalType, isRedispute, lowBalanceDisputeApplied, currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id), primaryText = _f.primaryText, primaryDataReason = _f.primaryDataReason, primaryDataType = _f.primaryDataType, primaryDataTitle = _f.primaryDataTitle;
    var _g = determineSecondaryButtonTitleAndText(step, errorData, isRedispute, lowBalanceDisputeApplied, currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.id), secondaryText = _g.secondaryText, secondaryDataReason = _g.secondaryDataReason, secondaryDataType = _g.secondaryDataType, secondaryDataTitle = _g.secondaryDataTitle;
    var _h = getHeaderAnalyticsTags(step, modalType, isRedispute), headerDataReason = _h.headerDataReason, headerDataTitle = _h.headerDataTitle, headerDataType = _h.headerDataType;
    var secondaryButtonType = determineSecondaryButtonType(step, lowBalanceDisputeApplied);
    var getModalHeaderContent = function () {
        if (modalType === ModalType.FAQs) {
            return t('faqs.modalTitle');
        }
        if (step === QuestionnaireFlow.CreditDetails) {
            return t('questionnaire.accountCredits');
        }
        if (isRedispute) {
            return t('disputeInfo.title');
        }
        return t('modal.title');
    };
    var stepsWithoutSecondaryButton = [
        QuestionnaireFlow.BusinessError,
        QuestionnaireFlow.Exit,
        QuestionnaireFlow.End,
        QuestionnaireFlow.CancelDispute,
        QuestionnaireFlow.RedisputeNotEligible,
        QuestionnaireFlow.CantIdentifyDup
    ];
    var handleSecondaryButtonClick = function () {
        if (source === ErrorSource.PostCases) {
            return null;
        }
        var viewWithoutSecondaryButton = modalType === ModalType.FAQs || stepsWithoutSecondaryButton.includes(step);
        if (viewWithoutSecondaryButton) {
            return null;
        }
        return function () {
            return dispatch(determineSecondaryButtonHandler(step, function () {
                return pointOfNeedChat(LaunchPointName.UploadDocs, accountId);
            }));
        };
    };
    var handlePrimaryButton = debounce(function () { return dispatch(handlePrimaryButtonClick()); }, 50);
    return (_jsx(SlideInModalPortal, __assign({ "aria-label": "".concat(t('label.questionnaireModal')), "aria-modal": "true", id: id !== null && id !== void 0 ? id : 'modal', containerId: SLIDE_IN_MODAL_CONTAINER_ID, isOpen: true, escapeModalHandler: onCloseModal, header: _jsx(DisputeModalHeader, { closeModal: onCloseModal, content: getModalHeaderContent(), "data-cy": "slide-in-modal-header", dataReason: headerDataReason, dataTitle: headerDataTitle, dataType: headerDataType }), footer: _jsx(CustomModalFooter, { dataCy: "slide-in-modal", dataPrimaryObject: "button", dataPrimaryReason: primaryDataReason, dataPrimaryTitle: primaryDataTitle, dataPrimaryType: primaryDataType, dataSecondaryObject: "button", dataSecondaryReason: secondaryDataReason, dataSecondaryTitle: secondaryDataTitle, dataSecondaryType: secondaryDataType, handlePrimaryButton: handlePrimaryButton, handleSecondaryButton: handleSecondaryButtonClick(), isPrimaryDisabled: primaryButtonDisabled, isSecondaryDisabled: secondaryButtonDisabled, primaryText: primaryText, secondaryButtonType: secondaryButtonType, secondaryText: secondaryText }) }, { children: children })));
};
export default SlideInModal;
//# sourceMappingURL=index.js.map